import '../layouts/ansysoft.css'
import coin from '../assets/prometa-coin.webp';
import webBullCoin from '../assets/Web-Bull-Coin.png'

function Footer() {
 const date = new Date().getFullYear();

    return (
        <>
            <div className="prometa-footer">
                <img src={webBullCoin} alt="WebBull Coin" width="148" height="148"/>
                    <p className="footer-text">{date} Copyrights &copy; WebBull. All Rights Reserved.</p>
            </div>
        </>
    )
}

export default Footer;